export const getFullName = (obj) => {
  return obj ? `${obj.firstName || ''} ${obj.lastName || ''}`.trimEnd() : '';
};

export const buildCardSelectEntry = (cardItem) => {
  const formattedExpMonth = String(cardItem?.expMonth || '').padStart(2, '0');
  const defaultSuffix = cardItem?.isDefault ? ' - DEFAULT' : '';

  return `•••• •••• •••• ${cardItem?.last4}-${formattedExpMonth}/${cardItem?.expYear}${defaultSuffix}`;
};
